<script lang="ts">
import MainStore from "@src/model/Main.Store";


import { onDestroy, onMount } from "svelte";


// NOTE: this is a svelte component only because we need to go along with
// the lifecycle of svelte.

let subscribeList: any[] = [];
onMount(() => {
    subscribeList.push(
        MainStore.getValue().currentVideoTimeStamp.subscribe((v) => {
            let interactionPointList = MainStore.getValue().currentInteractionPointList.getValue();
            for (let i = 0; i < interactionPointList.length; i++) {
                let v = interactionPointList[i];
                // NOTE: this 1/120 delta might be a bad choice... even this whole delta thing might
                // have been a bad choice.
                if (Math.abs(v.around - MainStore.getValue().currentVideoTimeStamp.getValue()) < (1/120)
                && (!MainStore.getValue().currentExecutingInteractionPoint.getValue())) {
                    console.log(MainStore.getValue().currentVideoTimeStamp.getValue());
                    MainStore.setCurrentExecutingInteractionPoint(v);
                    break;
                }
            };
        }),
    );
});
onDestroy(() => {
    subscribeList.forEach((v) => v());
});
</script>

<div style="user-select:none;visibility:hidden;">
</div>
